<template>
	<div class="custom-container">
		<div class="new-contract">
			<v-card v-if="!openRegister">
				<div class="current-contract" v-for="(item, key) in primaryProducts" :key="key">
					<div class="contract-info">
						<div class="product-icon"><v-icon>mdi-power-plug</v-icon></div>
						<div>
							<div class="label">{{ item.name }}</div>
							<div class="sublabel">{{ item.description ? item.description : ''}}</div>
						</div>
					</div>
					<v-btn @click="selectProduct(item)" outlined color="primary">endre avtale</v-btn>
				</div>
			</v-card>

			<div v-else class="wrap">
				<v-stepper class="form-stepper" v-model="step" vertical>
					
					<v-stepper-step :complete="step > 1" step="1">Hvem bestiller?</v-stepper-step>
					<v-stepper-content step="1">
						<v-card class="step-1">
							<div class="input-row">
								<v-text-field v-if="type === 'phone'" v-model="phone" autofocus :disabled="disablePhone" placeholder="Mobilnummer"></v-text-field>
							</div>

							<div v-if="type === 'phone'" class="input-row">
								<v-text-field v-if="disablePhone || nameVerify" v-model="firstName" :disabled="!nameVerify" placeholder="Fornavn"></v-text-field>
								<v-text-field v-if="disablePhone || nameVerify" v-model="lastName" :disabled="!nameVerify" placeholder="Etternavn"></v-text-field>
								<v-menu ref="birthdayPicker" v-if="nameVerify" v-model="birthdayPicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="200px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="formatedBirthday" append-icon="mdi-calendar" placeholder="Fødselsdag" v-mask="'##-##-####'" v-bind="attrs" v-on="on"></v-text-field>
									</template>
									<v-date-picker ref="picker" v-model="birthday" @change="saveBirthday"></v-date-picker>
								</v-menu>
							</div>

							<v-alert v-if="customerFindError" border="right" colored-border type="error" elevation="2" color="primary">
								Vi kunne ikke finne deg. Kontroller opplysningene og prøv igjen.
							</v-alert>

							<div class="submit-wrap">
								<v-btn v-if="disablePhone || nameVerify" class="submit-btn clear-btn" @click="clear()">Endre</v-btn>
								<v-btn v-if="step == 1" class="submit-btn find-btn primary ml-4" @click="findCustomer()">
									<span v-if="!findCustomerLoading">Finn meg</span>
									<v-progress-circular v-if="findCustomerLoading" indeterminate color="white" ></v-progress-circular>
								</v-btn>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="step > 2" step="2">Din strømmåler</v-stepper-step>
					<v-stepper-content step="2">
						<v-card class="step-2">
							<div class="label">Målepunkt hvor strømmen skal leveres</div>

							<div class="accounting-poins" v-if="accountingPoint && accountingPoint.length">
								<div v-for="(item, key) in accountingPoint" class="point list-point" :key="key">
									<v-checkbox v-model="checkboxes" :value="item.AccountingPoint.Identification"></v-checkbox>
									<div class="point-info">
										<div class="name">{{ item.AccountingPoint.Address.StreetName }} {{ item.AccountingPoint.Address.BuildingNumber }}, {{ item.AccountingPoint.Address.PostCode }} {{ item.AccountingPoint.Address.CityName }}</div>
										<div class="id">{{ maskAPid(item.AccountingPoint.Identification) }}</div>
									</div>
								</div>
							</div>

							<div class="accounting-poins custom-points" v-if="customAP.length">
								<div v-for="(item, key) in customAP" class="point" :key="key">
									<div class="list-point">
										<v-checkbox v-model="item.customAPcheck"></v-checkbox>
										<div class="point-info">
											<div class="name">{{ item.AccountingPoint.Address.StreetName }} {{ item.AccountingPoint.Address.BuildingNumber }}, {{ item.AccountingPoint.Address.PostCode }} {{ item.AccountingPoint.Address.CityName }}</div>
										</div>
									</div>

									<div class="label">Din strømmåler</div>
									<div class="sublabel">MålepunktID kan du finne på din strømfaktura. Har du ikke en faktura å se på kan du søke med målernummer, som du finner fysisk på din strømmåler. Har du ingen av delene kan du la dem stå tomme og så kontakter vi deg i etterkant. Eller du kan ringe kundeservice for å få hjelp. </div>

									<div class="input-row">
										<v-text-field v-model="item.apId" hide-details placeholder="MålepunktID (18 siffer)"></v-text-field>
										<p v-if="item.error" class="custom-error">Vi klarte ikke å finne målepunktet. Sjekk om tallene er riktig og prøv igjen.</p>
									</div>
									
									<p>eller</p>

									<div class="input-row id-post-input">
										<v-text-field class="id-input" v-model="item.apNumber" hide-details placeholder="Målernummer (16 siffer)"></v-text-field>
										<v-text-field class="post-code-input" v-model="item.AccountingPoint.Address.PostCode" hide-details placeholder="Postnummer" label="Postnummer"></v-text-field>
									</div>

									<div class="submit-wrap">
										<v-btn class="submit-btn long-submit-btn" @click="findAlternatives(key)">
											<span v-if="!item.loading">Finn strømmåler</span>
											<v-progress-circular v-if="item.loading" indeterminate color="primary" ></v-progress-circular>
										</v-btn>
									</div>
								</div>
							</div>

							<div v-if="editionalAddress" class="address-form">
								<div class="address-check">
									<v-checkbox v-model="addressCheck"></v-checkbox>
									<p>Adresse til strømmåleren din</p>
								</div>

								<div class="input-row">
									<v-text-field v-model="address.street" placeholder="Gate"></v-text-field>
									<v-text-field v-model="address.house" placeholder="Nummer"></v-text-field>
								</div>

								<div class="input-row">
									<v-text-field v-model="address.zip" placeholder="Postnummer" label="Postnummer"></v-text-field>
									<!-- <v-text-field v-model="address.city" placeholder="Poststed"></v-text-field> -->
								</div>
								
								<div class="submit-wrap">
									<v-btn class="submit-btn medium-submit-btn" @click="addAddress()">
										<span v-if="!findAddressLoading">Finn måler</span>
										<v-progress-circular v-if="findAddressLoading" indeterminate color="primary"></v-progress-circular>
									</v-btn>
									<v-btn v-if="customAP || leadDetails.AccountingPoints.length" class="submit-btn clear-bold-btn" @click="editionalAddress = false" text>Avbryt</v-btn>
								</div>
							</div>
							
							<div class="submit-wrap" v-if="(customAP && !editionalAddress) || (accountingPoint.length && !editionalAddress)">
								<v-btn class="submit-btn" @click="editionalAddress = true">Legg til bolig</v-btn>
							</div>

							<div class="date-wrap">
								<v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="200px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field :value="formatedDate" prepend-icon="mdi-calendar" placeholder="Ønsket oppstartsdato" readonly v-bind="attrs" v-on="on"></v-text-field>
									</template>
									<v-date-picker ref="picker" v-model="date" @change="save" :min="minDate"></v-date-picker>
								</v-menu>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-step :complete="step > 1" step="3">Bekreft din bestilling</v-stepper-step>
					<v-stepper-content step="3">
						<v-card class="step-3">
							<div class="label">Hvor skal vi sende bekreftelsen</div>
							<v-text-field v-model="submitEmail" hide-details placeholder="Din e-postadresse" outlined :rules="[rules.required, rules.email]"></v-text-field>

							<div class="privacy">
								<v-checkbox hide-details v-model="pravicy"></v-checkbox>
								<span v-if="privacyLink === 'klark'">Jeg godtar <a href="http://www.klarkraft.no/avtalevilkår" target="blank">avtalevilkårene</a></span>
								<span v-if="privacyLink === 'hks'">Jeg godtar <a href="https://www.helgelandkraft.no/strom/privat/vilkar/" target="blank">avtalevilkårene</a> og er kjent med <a href="https://www.helgelandkraft.no/globalassets/angreskjema.pdf" target="blank">angreretten</a></span>
							</div>

							<div class="submit-wrap" >
								<v-btn v-if="!processingOrder" class="submit-btn primary" @click="submitOrder">Bekreft din bestilling</v-btn>
                                <v-btn v-else class="submit-btn primary"><v-icon>mdi-loading mdi-spin</v-icon></v-btn>
							</div>
						</v-card>
					</v-stepper-content>
				</v-stepper>

				<!-- <div class="bottom-text">
					<p>Ingen bindingstid</p>
					<p>Alt håndteres automatisk av oss</p>
					<p>Få tilgang til all forbrukshistorikk på Minside</p>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import './NewContract.scss';

	import { newLead, leadByBirthday, accountingPointsAlternatives, orderPlace, findOrgByNumber } from "../../api/webOrder";
    import { writeCookie, readCookie } from '../../utils/session';

	export default {
		name: 'NewContract',

		components: {  },

		data(){
			return{
				menuClass: 'klarkraft',
				openRegister: false,
				step: 1,
				type: 'phone',
				nameVerify: false,
                phone: '',
                org: '',
                companyName: '',
                firstName: '',
                lastName: '',
                birthday: '',
                birthdayPicker: false,
				accountingPoint: [],
                checkboxes: [],
                formatedDate: '',
                date: '',
                menu: false,
                pravicy: false,
                disablePhone: false,
                street: '',
                house: '',
                zip: '',
                city: '',
                apId: '',
                apNumber: '',
                formatedBirthday: '',
                editionalAddress: false,
                address: {},
                customAP: [],
                customAPcheck: true,
                addressCheck: true,
                rules: {
                    required: value => !!value || 'Required.',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
                },
                leadDetails: '',
                submitEmail: '',
                findAPerror: false,
                findCustomerLoading: false,
                findAlternativesLoading: false,
                findAddressLoading: false,
                productDescription: '',
                productName: '',
                productId: '',
                productPrimary: true,
                commonLoader: true,
                customerFindError: false,
                minDate: '',
                contactPhone: '',
                privacyLink: '', 
                processingOrder: false
			}
		},

		mounted(){
            writeCookie();
            
            this.minDate = this.$moment(new Date()).subtract(40,'d').toISOString();
        },

		watch: {
            checkboxes(val){
                if(val.length && this.date){
                    this.step = 3;
                }
            },

            step(val) {
                if(val == 2 && !this.accountingPoint.length && this.leadDetails.SSN && this.leadDetails.Address.PostCode){
                    this.customAP.push({
                        AccountingPoint: {
                            Address: {
                                BuildingNumber: this.leadDetails.Address.BuildingNumber,
                                CityName: this.leadDetails.Address.CityName,
                                PostCode: this.leadDetails.Address.PostCode,
                                StreetName: this.leadDetails.Address.StreetName
                            }
                        },
                        customAPcheck: true,
                        apId: '',
                        apNumber: '',
                        error: false,
                        loading: false
                    });
                }
            },

            birthday(val) {
                if(val){
                    this.formatedBirthday = this.$moment(val).format('DD-MM-YYYY');
                }
            },

            date(val){
                if(val){
                    this.formatedDate = this.$moment(val).format('DD-MM-YYYY');
                }
            },

			account(val){
				if(val){
					let phone = val.Communication.find(item => {
						return item.Channel === "Mobile";
					}),
					email = val.Communication.find(item => {
						return item.Channel === "Email";
					});

					this.phone = phone.Value;
					this.email = email.Value;

					console.log(this.phone);
				}
			},

			user(val){
				if(val){
					this.firstName = val.GivenName;
					this.lastName = val.FamilyName;
				}
			}
        },

		computed: {
			primaryProducts(){
				let products = this.$store.getters['getPrimaryProducts'];
				
				return products;
			},
			
			contracts(){
				return this.$store.getters['getContracts'];
			},

			user(){
				return this.$store.getters['getUser'];
			},

			account(){
				return this.$store.getters['getAccount'];
			},

			selectedContract: {
				get () {
					return this.$store.getters['getSelectedContract'];
				},

				set (value) {
					let contract = this.contracts.find(item => {
						return item.id === value;
					});
					
					if(contract){
						this.$store.commit('setSelectedContract', contract);
					}
				}
			}
		},

		methods: {
			selectProduct(item){
				this.productDescription = item.description;
				this.productName = item.name;
				this.productPrimary = item.primaryProduct;
				this.productId = item.id;

				this.openRegister = true;
			},

			maskAPid(id){
                return id.replace(id.substring(10, 14), '****');
            },

            isSummertime(date){
                const year = date.getFullYear();
                if (date.getMonth() <= 1) {
                    return false;
                } else if (date.getMonth() === 2) {
                    const lastSunday = this.getLastSunday(year, 2);
                    if ((date.getDate() + 1 ) <= lastSunday.getDate() ) {
                        return false;
                    } else {
                        return true;
                    }
                } else if (date.getMonth() >= 3 && date.getMonth() <= 8) {
                    return true;
                } else if (date.getMonth() === 9) {
                    const lastSunday = this.getLastSunday(year, 9);
                    if ((date.getDate() + 1 ) <= lastSunday.getDate() ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },

            getLastSunday(year, month) {
                const sundays = [];
                for (let i = 1; i <= 31; i++) {
                    const thisDate = new Date(year, month, i);
                    if (thisDate.getDay() === 0) {
                        sundays.push(thisDate);
                    }
                }
                return sundays.pop();
            },

            newLead(data){
                return new Promise((resolve, reject) => {
                    newLead(data).then(res => {
                        if(res.data){
                           resolve(res.data); 
                        }

                    }).catch(error => {
                        console.log(error);
                        resolve(error);
                        reject(error);
                    })
                });
            },

            leadByBirthday(data){
                return new Promise((resolve, reject) => {
                    leadByBirthday(data).then(res => {
                        if(res.data){
                           resolve(res.data); 
                        }
                    }).catch(error => {
                        console.log(error);

                        reject(error);
                    });
                });
            },

            getAccountingPoints(data){
                return new Promise((resolve, reject) => {
                    accountingPointsAlternatives(data).then(res => {
                        console.log(res);
                        if(res.data){
                           resolve(res.data); 
                        }
                    }).catch(error => {
                        console.log(error);

                        reject(error);
                    });
                });
            },

            orderPlace(data){
                return new Promise((resolve, reject) => {
                    orderPlace(data).then(res => {
                        console.log(res);
                        if(res.data){
                           resolve(res.data); 
                        }
                    }).catch(error => {
                        console.log(error);

                        reject(error);
                    });
                });
            },
            
            addAddress(){
                if(this.address && this.addressCheck){
                    let address = this.address;

                    if(this.leadDetails.SSN){
                        this.findAddressLoading = true;

                        let data = {
                            SessionId: readCookie(),
                            SSN: this.leadDetails.SSN,
                            Address: {
                                StreetName: address.street,
                                PostCode: address.zip,
                                BuildingNumber: address.house,
                                CityName: address.city
                            }
                        }

                        this.getAccountingPoints(data).then(res => {
                            if(res.LeadDetails && (res.LeadDetails.AccountingPoints.length !== this.accountingPoint.length)){
                                this.accountingPoint = res.LeadDetails.AccountingPoints;

                                let checkboxes = [];

                                res.LeadDetails.AccountingPoints.forEach(item => {
                                    checkboxes.push(item.AccountingPoint.Identification);
                                });
                                
                                this.checkboxes = checkboxes;
                                
                                this.leadDetails = res.LeadDetails;
                                this.address = {
                                    house: '',
                                    street: '',
                                    zip: '',
                                    city: ''
                                }
                            }else{
                                this.customAP.push({
                                    AccountingPoint: {
                                        Address: {
                                            StreetName: address.street,
                                            PostCode: address.zip,
                                            BuildingNumber: address.house,
                                            CityName: address.city
                                        }
                                    },
                                    customAPcheck: true,
                                    apId: '',
                                    apNumber: '',
                                    error: false,
                                    loading: false
                                });
                            }

                            this.findAddressLoading = false;
                            this.editionalAddress = false;
                        });
                    }
                }
            },

            findAlternatives(key){
                let customAP = this.customAP.find((item, index) => {
                    return index === key;
                });

                if(customAP.customAPcheck){
                    this.customAP[key].loading = true;

                    let data = {
                        SessionId: readCookie(),
                        SSN: this.leadDetails.SSN,
                        Address: {
                            PostCode: customAP.AccountingPoint.Address.PostCode,
                            StreetName: customAP.AccountingPoint.Address.StreetName,
                            BuildingNumber: customAP.AccountingPoint.Address.BuildingNumber
                        }
                    }

                    if(customAP.apId){
                        data.AccountingPointId = customAP.apId
                    }

                    if(customAP.apNumber){
                        data.MeterNumber = customAP.apNumber;
                    }

                    this.getAccountingPoints(data).then(res => {
                        if(res.LeadDetails && (res.LeadDetails.AccountingPoints.length !== this.accountingPoint.length)){
                            this.customAP.splice(key, 1);
                            this.accountingPoint = res.LeadDetails.AccountingPoints;
                            
                            this.checkboxes.push(customAP.apId);

                            this.leadDetails = res.LeadDetails;

                            this.findAPerror = false;
                        }else{
                            this.customAP[key].error = true;
                        }

                        this.customAP[key].loading = false;
                        this.editionalAddress = false;
                    });
                }
            },

            findCustomer(){
                if(this.type === 'phone'){
                    let phone = this.phone.replace(/\s/g, ""),
                        firstName = this.firstName,
                        lastName = this.lastName;
                    
                    if(!this.nameVerify && phone){
                        this.findCustomerLoading = true;
                        if(phone.indexOf('+47') === -1){
                            phone = '+47' + phone;
                        }

                        let data = {
                            Phone: phone,
                            MockResponse: false,
                            SessionId: readCookie(),
                            Product: {
                                ProductId: this.productId,
                                ProductName: this.productName,
                                PrimaryProduct: this.productPrimary
                            }
                        }

                        this.newLead(data).then(res => {
                            this.customerFindError = false;
                            this.findCustomerLoading = false;

                            if(res.status == 404){
                                this.nameVerify = true;

                                return;
                            }

                            if(res.LeadDetails){
                                if(res.LeadDetails.SSN){
                                    if(res.LeadDetails.Address.PostCode){
                                        let address = {
                                            ssn: res.LeadDetails.SSN
                                        };

                                        this.address = address;
                                    }else if(!res.LeadDetails.AccountingPoints.length){
                                        this.editionalAddress = true;
                                    }
                                    
                                    if(res.LeadDetails.AccountingPoints.length){
                                        let checkboxes = [];

                                        res.LeadDetails.AccountingPoints.forEach(item => {
                                            checkboxes.push(item.AccountingPoint.Identification);
                                        });
                                        
                                        this.checkboxes = checkboxes;
                                    }

                                    this.firstName = res.LeadDetails.FirstName;
                                    this.lastName = res.LeadDetails.LastName;
                                    this.accountingPoint = res.LeadDetails.AccountingPoints;
                                    this.step = 2;
                                    this.disablePhone = true;
                                }else{
                                    this.nameVerify = true;
                                    this.disablePhone = true;
                                }

                                this.leadDetails = res.LeadDetails
                            }
                            
                        })
                    }else{
                        if(firstName && lastName && this.formatedBirthday){
                            let date = this.formatedBirthday.split('-').join(""),
                                birthday = date;

                            if(date.length > 6){
                                let firstDate = date.substring(0, 4),
                                lastDate = date.substring(6, 8);

                                birthday = firstDate + lastDate;
                            }
                            
                            this.findCustomerLoading = true;

                            let data = {
                                BirthDay: birthday,
                                FirstName: firstName,
                                LastName: lastName,
                                SessionId: readCookie()
                            }

                            this.leadByBirthday(data).then(res => {
                                this.findCustomerLoading = false;
                                this.customerFindError = false;

                                if(res.LeadDetails){
                                    if(res.LeadDetails.SSN){
                                        this.findCustomerLoading = false;

                                        if(res.LeadDetails.Address.PostCode){
                                            let address = {
                                                ssn: res.LeadDetails.SSN
                                            };

                                            this.address = address;
                                        }else if(!res.LeadDetails.AccountingPoints.length){
                                            this.editionalAddress = true;
                                        }
                                        
                                        if(res.LeadDetails.AccountingPoints.length){
                                            let checkboxes = [];

                                            res.LeadDetails.AccountingPoints.forEach(item => {
                                                checkboxes.push(item.AccountingPoint.Identification);
                                            });
                                            
                                            this.checkboxes = checkboxes;
                                        }
                                        
                                        this.firstName = res.LeadDetails.FirstName;
                                        this.lastName = res.LeadDetails.LastName;
                                        this.accountingPoint = res.LeadDetails.AccountingPoints;
                                        this.step = 2;
                                        this.disablePhone = true;
                                        this.formatedBirthday = '';
                                        this.nameVerify = false; 
                                    }else{
                                        this.customerFindError = true;
                                    }

                                    this.leadDetails = res.LeadDetails
                                }
                            })
                        }
                    }
                }else{
                    if(this.org){
                        return new Promise((resolve, reject) => {
                            findOrgByNumber(this.org).then(res => {
                                let data = {
                                    Phone: this.org,
                                    MockResponse: false,
                                    SessionId: readCookie(),
                                    Product: {
                                        ProductId: this.productId,
                                        ProductName: this.productName,
                                        PrimaryProduct: this.productPrimary
                                    }
                                }

                                this.newLead(data).then(res => {
                                    console.log(res);
                                });

                                if(res.data){
                                    let subAddress = [];

                                    if(res.data.forretningsadresse.adresse.length > 1){
                                        subAddress = res.data.forretningsadresse.adresse[1].split(' ');
                                    }else{
                                        subAddress = res.data.forretningsadresse.adresse[0].split(' ');
                                    }

                                    let buildNumb = subAddress[subAddress.length - 1];

                                    subAddress.pop();
                                    
                                    let address = {
                                        street: subAddress.join(' '),
                                        house: buildNumb,
                                        zip: res.data.forretningsadresse.postnummer,
                                        city: res.data.forretningsadresse.kommune,
                                    }

                                    this.companyName = res.data.navn;
                                    this.step = 2;
                                    this.disablePhone = true;

                                    this.customAP.push({
                                        AccountingPoint: {
                                            Address: {
                                                StreetName: address.street,
                                                PostCode: address.zip,
                                                BuildingNumber: address.house,
                                                CityName: address.city
                                            }
                                        },
                                        customAPcheck: true,
                                        apId: '',
                                        apNumber: '',
                                        error: false,
                                        loading: false
                                    });
                                }
                            }).catch(error => {
                                console.log(error);

                                reject(error);
                            });
                        });
                    }
                }
                
            },

            submitOrder(){
                
                if(this.submitEmail && this.pravicy){
                    this.processingOrder = true; 
                    let date = '';

                    if(this.date){
                        if (this.isSummertime(new Date(this.date))) {
                            date = this.$moment(this.date).format("YYYY-MM-DDT00:00:00+02:00");
                        } else {
                            date = this.$moment(this.date).format("YYYY-MM-DDT00:00:00+01:00");
                        }
                    }else{
                        if (this.isSummertime(new Date())) {
                            date = this.$moment().add(2,'days').format("YYYY-MM-DDT00:00:00+02:00");
                        } else {
                            date = this.$moment().add(2,'days').format("YYYY-MM-DDT00:00:00+01:00");
                        }
                    }

                    let accountingPoints = [];

                    this.checkboxes.map(item => {
                        accountingPoints.push({'Identification': item});
                    });

                    let data = {
                        Address: this.leadDetails.Address,
                        Email: this.submitEmail,
                        Phone: this.leadDetails.Phone,
                        StartDate: date,
                        SessionId: readCookie(),
                        AccountingPoints: accountingPoints,
                        FirstName: this.leadDetails.FirstName,
                        LastName: this.leadDetails.LastName,
                        Product: this.leadDetails.Product,
                        SSN: this.leadDetails.SSN
                    }

                    this.orderPlace(data).then(res => {
                        if(res.Message == 'Request accepted'){
                            this.clear();
                            this.$router.push('thankyou');
                        }
                    });
                }else{
                    console.log("Noe har gått galt")
                }
               
            },

            save (date) {
                this.$refs.menu.save(date)
            },

            saveBirthday (date) {
                this.$refs.birthdayPicker.save(date)
            },

            clear(){
                this.step = 1;
                this.nameVerify = false;
                this.phone = '';
                this.firstName = '';
                this.lastName = '';
                this.birthday = '';
                this.formatedBirthday = '';
                this.accountingPoint = [];
                this.checkboxes = [];
                this.date = null;
                this.pravicy = false;
                this.disablePhone = false;
                this.street = '';
                this.house = '';
                this.zip = '';
                this.city = '';
                this.apId = '';
                this.apNumber = '';
                this.editionalAddress = false;
                this.findCustomerLoading = false;
                this.findAlternativesLoading = false;
                this.findAddressLoading = false;
                this.customAP = [];
                this.accountingPoint = [];
                this.checkboxes = [];
                this.customerFindError = false;
                this.processingOrder = false;

                writeCookie();
            }
		}
	}
</script>
